(function (Drupal, $, settings) {
  Drupal.behaviors.dennysTheming = {
    attach: function attach(context) {
      $('.block-menu-block-dennys-mainnavigation li:has(a[href="/order"])').hide(); // Firefox support
      $('#block-mainnavigation-2 a[href="/rewards"]').parent().hide();
      $('.block-menu-block-dennys-mainnavigation li').each(function() {
         if ($(' span' , this).text() == Drupal.t('Locations')) {
           $(this).show();
          }
      });
      const data = localStorage.getItem('reduxStore');
      let appState = null;

      if (data && data.length) {
        const json = Flatted.parse(data);
        appState = json.appState;
        Object.freeze(appState);
        if (appState.authentication && appState.authentication.firstname.length) {
          $('body').addClass('rewards-authenticated');
          //$('.layout__region--mobile-header .authorized-menu').css('display','flex');
          $('.layout__region--mobile-header .log-out').css('display','flex');
          $('.layout__region--mobile-header .sign-up').hide();
          $('.layout__region--mobile-header .log-in').hide();
          //$('.sign-in a').attr('href', '/account/settings');
          $('.block-block-content30f0a7cc-cafa-4123-9b41-b8d996f47dba').hide();
          $('.main-menu a[href="/rewards"] span.link-title, .block-menu-block-explore a[href="/rewards"]').text(Drupal.t('My Offers'));
          $('.main-menu a[href="/rewards"]').attr('href', '/order/rewards');
          $('.block-menu-block-explore a[href="/rewards"]').attr('title', Drupal.t('My Offers')).attr('href', '/order/rewards');
        }
      }
      if (!data || appState === null || (appState && (!appState.hasOwnProperty('authentication') || appState.authentication === null))) {
          $('.block-menu-block-mainnavigation-2 a[href="/rewards"] span.link-title').text(Drupal.t("Denny's Rewards"));
          // The logged-out flyout rewards CTA (R logo + "Join Rewards…" tagline +
          // Create Account + Sign In) is rendered statically in the social-links
          // block template now, matching the orderonline storefront. No injected
          // rewards lockup / promo copy / sign-in text needed.
      }
    }
  }

  Drupal.behaviors.mobileAppBanner = {
    attach: function attach(context) {
      const appBanner = $(".block.app-store-banner");
      if (appBanner.length > 0) {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        if (/Android|iPhone|iPad|iPod/i.test(userAgent)) {
          $('body').addClass('is-mobile');
          if (/Android/i.test(userAgent)) {
            const url = $('.block.app-store-banner a').data('app-android');
            $('.block.app-store-banner a.btn-app-store').attr('href', url);
          }
          if (/iPhone|iPad|iPod/i.test(userAgent)) {
            const url = $('.block.app-store-banner a').data('app-ios');
            $('.block.app-store-banner a.btn-app-store').attr('href', url);
          }
        }
      }
    }
  }

  Drupal.behaviors.homepageEvents = {
    attach: function attach(context) {
      if ($('body').hasClass('path-frontpage')) {
        var dataLayer = window.dataLayer = window.dataLayer || [];
        // Header nav links
        $('#block-dennys-mainnavigation .main-menu a, #block-dennys-mainnavigation .main-menu button, .header__secondary a#mpel-language-toggle, .header__secondary .header__sign-in, .header__secondary a.header__cart, .header__secondary a.header__order').click(function() {
          dataLayer.push({
            'event': 'nav_click',
            'parent_section': 'primary nav'
          });
        });
        // Hero
        $('#homepage-hero--section .hero__content .field-item__field-ctas .button').click(function() {
          dataLayer.push({
            'event': 'cta_click',
            'link_text': $(this).text().trim().toLowerCase(),
            'parent_section': 'hero carousel'
          });
        });
        // Menu items block
        $('#homepage-menu--section .block-block-content.menu .menu-items .field-item__field-items').each(function(index, element) {
          let blockTitle = $('#homepage-menu--section .block-block-content.menu h1').text().trim();
          blockTitle = blockTitle + ' ' + $('#homepage-menu--section .block-block-content.menu h2').text().trim();
          $(element).find('a.button.primary').click(function() {
            dataLayer.push({
              'event': 'cta_click',
              'link_text': $(this).text().trim().toLowerCase(),
              'parent_section': blockTitle,
              'index': index + 1
            });
          });
          $(element).find('a.plus-icon').click(function() {
            dataLayer.push({
              'event': 'cta_click',
              'link_text': $(this).text().trim().toLowerCase(),
              'parent_section': blockTitle,
              'index': index + 1
            });
          });
        });
        // 5050 blocks
        $('#homepage-menu--section .layout__region .fifty-fifty-block .fifty-fifty-block__cta__wrapper--stacked .button, #aarp-members .layout__region .fifty-fifty-block .fifty-fifty-block__cta__wrapper--stacked .button').click(function() {
          let blockTitle = $(this).closest('.fifty-fifty-block__cta__wrapper--stacked').siblings('h2').text().trim();
          dataLayer.push({
            'event': 'cta_click',
            'link_text': $(this).text().trim().toLowerCase(),
            'parent_section': blockTitle
          });
        });
        // AARP 5050 block
        $('#aarp-members .layout__region .fifty-fifty-block .fifty-fifty-block__cta__wrapper-- .button').click(function() {
          let blockTitle = $(this).closest('.fifty-fifty-block__cta__wrapper--').siblings('h2').text().trim();
          dataLayer.push({
            'event': 'cta_click',
            'link_text': $(this).text().trim().toLowerCase(),
            'parent_section': blockTitle
          });
        });
        // Social impact heading
        $('#homepage-our-social-impact--section .tertiary.button').click(function() {
          let blockTitle = $(this).parent('.field-item__field-cta').siblings('.field-item__field-eyebrow').text().trim();
          blockTitle = blockTitle + ' ' + $(this).parent('.field-item__field-cta').siblings('h2').text().trim();
          dataLayer.push({
            'event': 'cta_click',
            'link_text': $(this).text().trim().toLowerCase(),
            'parent_section': blockTitle
          });
        });
        // Social impact slider
        $('#homepage-our-social-impact--section .main-swiper-container .fifty-fifty-block.swiper-slide').each(function(index, element) {
          let blockTitle = $(element).find('.eyebrow').text().trim();
          blockTitle = blockTitle + ' ' + $(element).find('h2').text().trim();
          $(element).find('a.primary.button').click(function() {
            dataLayer.push({
              'event': 'cta_click',
              'link_text': $(this).text().trim().toLowerCase(),
              'parent_section': blockTitle,
              'index': index + 1
            });
          });
        });
        // Footer nav links
        $('footer .bottom-footer .socials a, footer .bottom-footer .store-ctas a, footer .bottom-footer .block-menu-system-menu-blockexplore a, footer .bottom-footer .block-menu-system-menu-blockabout a, footer .bottom-footer .block-menu-system-menu-blockvalues a').click(function() {
          dataLayer.push({
            'event': 'nav_click',
            'parent_section': 'footer nav'
          });
        });
      }
    }
  }
})(Drupal, jQuery, drupalSettings);

